module.exports = __webpack_public_path__ + "static/newl.7f7af9cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newl.png
// module id = 3166
// module chunks = 199180123508537